import {Stack, Grid, Typography, Box, Skeleton} from "@mui/material"
import {FC} from "react"
import {BookMark} from "../../../assets"
import EllipsisTypography from "../../atoms/customTypography/EllipsisTypography"
import ImageAvatar from "../../atoms/imageAvatar/ImageAvatar"
import EmailButton from "../../atoms/emailButton/EmailButton"
import {Account, AccountTeam} from "../../../types"
import {TruncatedTooltip} from "../../atoms/Tooltip"

type Props = {
  authorName: string
  imagePath: string
  location: string
  tags: string[]
  loading: boolean
  selectedMember: AccountTeam
  contactData: Account
  contactTeamData: AccountTeam[]
}

const ExpertBioHeader: FC<Props> = (props) => {
  const {
    authorName,
    imagePath,
    location,
    tags,
    loading,
    selectedMember,
    contactData,
    contactTeamData,
  } = props

  return (
    <Grid container direction="row" flexWrap="nowrap" spacing={1}>
      <Grid
        sx={{
          width: "108px",
        }}
      >
        {!loading ? (
          <ImageAvatar src={imagePath} size={"80px"} />
        ) : (
          <Skeleton
            variant="circular"
            width={"80px"}
            height={"80px"}
            sx={{
              flexGrow: 0,
              backgroundImage:
                "linear-gradient(to right, #cacdcd 0%, #DEDEDE 100%)",
              margin: "8px",
            }}
          />
        )}
      </Grid>
      <Grid
        sx={{
          width: "344px",
        }}
      >
        <Stack direction={"column"}>
          {!loading ? (
            <>
              <Box
                component={"div"}
                sx={{
                  height: "20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  component={"div"}
                  sx={{
                    flex: "0 1 auto",
                    width: "100%",
                    height: "20px",
                    flexGrow: 0,
                    fontFamily: "Open Sans",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    letterSpacing: "normal",
                    color: "#1c1c1c",
                  }}
                >
                  <EllipsisTypography
                    lines={1}
                    fontSize={14}
                    text={authorName}
                    tooltipComponent={TruncatedTooltip}
                  />
                </Box>
                <Box sx={{display: "flex", height: "20px"}}>
                  <Box
                    component={"div"}
                    sx={{display: "none", cursor: "pointer"}}
                  >
                    <BookMark
                      height={"26px"}
                      width={"20.9px"}
                      fill={"#053747"}
                    />
                  </Box>
                  <Box component={"div"}>
                    <EmailButton
                      height={"20.1"}
                      width={"26px"}
                      fill={"#053747"}
                      selectedMember={selectedMember!!}
                      contactData={contactData!!}
                      contactTeamData={contactTeamData!!}
                    />
                  </Box>
                </Box>
              </Box>
              <Box>
                <Typography
                  align="left"
                  sx={{
                    flexGrow: 0,
                    fontFamily: "Open Sans",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: 1.33,
                    letterSpacing: "normal",
                    color: "#595958",
                  }}
                >
                  {location}
                </Typography>
              </Box>
              <Box sx={{width: "315px"}}>
                <Typography
                  align="left"
                  sx={{
                    flexGrow: 0,
                    fontFamily: "Open Sans",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: 1.33,
                    letterSpacing: "normal",
                    color: "#595958",
                  }}
                >
                  {tags.map((tag, index) => (
                    <>
                      <span
                        style={{
                          lineHeight: "16px",
                        }}
                      >
                        {tag.trim()}&nbsp;
                      </span>
                      {index < tags.length - 1 && (
                        <Box
                          component={"div"}
                          sx={{
                            display: "inline-block",
                            justifyContent: "center",
                            alignContent: "center",
                            padding: "0px 3px 0px 0px",
                          }}
                        >
                          <Box
                            component={"div"}
                            sx={{
                              display: "inline-block",
                              background: "#242d35",
                              width: "0.8px",
                              height: "8.9px",
                            }}
                          ></Box>
                        </Box>
                      )}
                    </>
                  ))}
                </Typography>
              </Box>
            </>
          ) : (
            <>
              <Box
                component={"div"}
                sx={{
                  flex: "0 1 auto",
                  width: "100%",
                  flexGrow: 0,
                  fontFamily: "Open Sans",
                  fontSize: "14px",
                  fontWeight: "normal",
                  fontStretch: "normal",
                  fontStyle: "normal",
                  letterSpacing: "normal",
                  color: "#1c1c1c",
                  display: "flex",
                }}
              >
                <Box padding="15px 5px" width={"80%"}>
                  {[1, 2, 3].map((index) => (
                    <Skeleton
                      key={index}
                      variant="rectangular"
                      animation="wave"
                      height={"20px"}
                      width={"80%"}
                      sx={{
                        flexGrow: 0,
                        backgroundImage:
                          "linear-gradient(to right, #cacdcd 0%, #DEDEDE 100%)",
                        margin: "2px",
                      }}
                    />
                  ))}
                </Box>
                <Box sx={{display: "flex", height: "20px", width: "20%"}}>
                  <Box
                    component={"div"}
                    sx={{display: "none", cursor: "pointer"}}
                  >
                    <Skeleton
                      variant="rectangular"
                      animation="wave"
                      height={"20.1px"}
                      width={"26px"}
                      sx={{
                        flexGrow: 0,
                        backgroundImage:
                          "linear-gradient(to right, #cacdcd 0%, #DEDEDE 100%)",
                      }}
                    />
                  </Box>
                  <Box component={"div"} sx={{cursor: "pointer"}}>
                    <Skeleton
                      variant="rectangular"
                      animation="wave"
                      height={"20.1px"}
                      width={"26px"}
                      sx={{
                        flexGrow: 0,
                        backgroundImage:
                          "linear-gradient(to right, #cacdcd 0%, #DEDEDE 100%)",
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </Stack>
      </Grid>
    </Grid>
  )
}

export default ExpertBioHeader
